import { cn } from '@ifixit/ui/lib/utils';

interface BlueDotProps {
   className?: string;
}

export function BlueDot({ className }: BlueDotProps) {
   return (
      <div
         className={cn(
            'size-3.5 rounded-full border-2 border-solid border-gray-900 bg-brand-500',
            className
         )}
      />
   );
}
